import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  getPayments,
  getAllQuotationIds,
  deletePayment,
  getVoucherNumber,
} from "../../services/apiPayment";
import { getAllCustomers } from "../../services/apiSettings";
import { Box, Typography, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Addpayment from "./AddPayment";
import Swal from "sweetalert2";
import "../../css/payment.css";
import PopUp from "../PopUp";
import ViewCustomerVoucher from "./ViewCustomerVoucher";
import Select from "react-select";
import Loader from "../Loader";

const CustomerPayments = () => {
  const Group = require("../../assets/images/payments.png");
  const paymentIcon = require("../../assets/images/payment-icon.png");
  const [QuotationList, setQuotationList] = useState([]);
  const [ButtonId, SetButtonId] = useState();
  const [customerList, setCustomerList] = useState([]);
  const [selectedCustomerid, setSelectedCustomerid] = useState("");
  const [totalInvoiceAmount, setInvoiceAmount] = useState(0);
  const [paidAmount, setPaidAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [balanceAmount, setBalanceAmount] = useState(0);
  const [open, setOpen] = useState(false);
  const [customerpayment, setCustomerpayment] = useState([]);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const { customerId } = location.state || {};
  const [period, setPeriod] = useState("");
  const [inputFromDate, setInputFromDate] = useState("");
  const [inputToDate, setInputToDate] = useState("");
  const [inputpdaId, setPdaId] = useState("");
  const [FilterName, setFilterName] = useState("");
  const [FilterValue, setFilterValue] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [message, setMessage] = useState("");
  const [openPopUp, setOpenPopUp] = useState(false);
  const [errors, setErrors] = useState({});
  const [dateError, setDateError] = useState("");
  const [voucherNumber, setVoucherNumber] = useState(false);
  const [viewopen, setviewOpen] = useState(false);
  const [isDirectCustomerPayment, setIsDirectPayment] = useState(false);
  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      height: "30px !important",
      minWidth: "0",
      width: "100%",
      maxWidth: "100%",
      marginTop: "14px",
      borderRadius: "0.375rem",
      borderColor: "#dee2e6",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#dee2e6",
      },
      Padding: "0px !important",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      marginTop: "2px", // Reduced spacing between select and dropdown
      Padding: "0px !important",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#0d6efd"
        : state.isFocused
        ? "#e9ecef"
        : "white",
      color: state.isSelected ? "white" : "black",
      cursor: "pointer",
      fontSize: "0.7rem !important", // Option font size
      Padding: "0px !important",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "0.7rem !important", // Option font size
      color: "#000000", // Black color for placeholder
      Padding: "0px !important",
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "0.7rem !important", // Option font size
      color: "#000000",
      Padding: "0px !important",
    }),
    input: (provided) => ({
      ...provided,
      fontSize: "0.7rem !important", // Option font size
      color: "#000000",
      height: "30px !important",
      Padding: "0px !important",
    }),
  };
  // Helper to get correct isDirectPayment value
  const getIsDirectPaymentValue = () => (isDirectCustomerPayment ? true : "");
  const sanitizePayload = (payload) =>
    Object.fromEntries(
      Object.entries(payload).filter(
        ([, value]) => value !== "" && value !== null && value !== undefined,
      ),
    );
  const isDateRangeValid = (fromDate, toDate) =>
    !fromDate || !toDate || fromDate <= toDate;
  const getPeriodFilterPayload = (
    filterName = FilterName,
    filterValue = FilterValue,
  ) => (filterName ? { filter: filterName, [filterName]: filterValue } : {});
  const buildCustomerPaymentPayload = ({
    customerIdValue = selectedCustomerid || customerId,
    fromDate = inputFromDate,
    toDate = inputToDate,
    pdaId = inputpdaId,
    filterName = FilterName,
    filterValue = FilterValue,
    isDirectPayment = getIsDirectPaymentValue(),
  } = {}) =>
    sanitizePayload({
      customerId: customerIdValue,
      fromDate,
      toDate,
      pdaId,
      ...getPeriodFilterPayload(filterName, filterValue),
      isDirectPayment,
    });

  const fetchCustomerList = async () => {
    try {
      const listcustomers = await getAllCustomers();
      setCustomerList(listcustomers?.customers || []);
    } catch (error) {
      console.log("Cannot fecth customer", error);
    }
  };
  const fecthQuotations = async () => {
    try {
      const listquotations = await getAllQuotationIds();
      setQuotationList(listquotations?.quotations || []);
    } catch (error) {
      console.log("Invoice list Error", error);
    }
  };

  const fetchVoucherNumber = async () => {
    const listvoucherNumber = await getVoucherNumber();
    const fetchedvoucherNumber = listvoucherNumber?.voucherNumber || [];
    setVoucherNumber(fetchedvoucherNumber);
  };

  const loginResponse = JSON.parse(localStorage.getItem("loginResponse"));
  const currentroleType = loginResponse.data?.userRole?.roleType;

  useEffect(() => {
    fetchVoucherNumber();
    fetchCustomerList();
    fecthQuotations();
    if (customerId) setSelectedCustomerid(customerId);
    const payload = buildCustomerPaymentPayload({ customerIdValue: customerId });
    fetchCustomerpayments(payload);
  }, [customerId]);

  const fetchCustomerpayments = async (payload) => {
    setIsLoading(true);
    try {
      const Listpayments = await getPayments(payload);
      console.log(Listpayments, "Listpayments");
      setCustomerpayment(Listpayments?.payments || []);
      setInvoiceAmount((Listpayments?.totalInvoiceAmount || 0).toFixed(3));
      setPaidAmount((Listpayments?.paidAmount || 0).toFixed(3));
      setDiscountAmount((Listpayments?.discountAmountOMR || 0).toFixed(3));
      const totalAmount = Listpayments?.totalInvoiceAmount || 0;
      const amountpaid = Listpayments?.paidAmount || 0;
      const discount = Listpayments?.discountAmountOMR || 0;
      const balance = totalAmount - amountpaid - discount;
      setBalanceAmount(parseFloat(balance.toFixed(3)));
      setIsLoading(false);
    } catch (error) {
      console.log("Error in Api", error);
      setIsLoading(false);
    }
  };

  const handleListCustomer = (payload) => {
    setEditMode(false);
    fetchCustomerpayments({
      ...payload,
      isDirectPayment: getIsDirectPaymentValue(),
    });
    setOpen(false);
  };

  const handleChange = (e) => {
    const selectedCustomer = e.target.value;
    setSelectedCustomerid(selectedCustomer);
    if (!isDateRangeValid(inputFromDate, inputToDate)) {
      setDateError("From Date should not be greater than To Date");
      return;
    }
    setDateError("");
    const paylaod = buildCustomerPaymentPayload({
      customerIdValue: selectedCustomer,
    });
    fetchCustomerpayments(paylaod);
  };
  const OpenDialog = (buttonId) => {
    SetButtonId(buttonId);
    handClickOpen();
  };
  const handClickOpen = () => {
    setOpen(true);
  };
  const resetErrors = () => {
    setErrors({});
  };
  const handleClose = () => {
    fetchVoucherNumber();
    setOpen(false);
    setEditMode(false);
    setSelectedRow(null);
    resetErrors();
  };

  useEffect(() => {
    console.log(ButtonId, "ButtonId in useEffect");
  }, [ButtonId]);

  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const years = [2024, 2025, 2026, 2027, 2028, 2029, 2030];
  const handleTimeperiod = async (e) => {
    const SelectBxname = e.target.name;
    if (!isDateRangeValid(inputFromDate, inputToDate)) {
      setDateError("From Date should not be greater than To Date");
      return;
    }
    setDateError("");
    let payload = {};
    if (SelectBxname === "pdaId") {
      setPdaId(e.target.value);
      payload = buildCustomerPaymentPayload({ pdaId: e.target.value });
    } else {
      setFilterName(SelectBxname);
      setFilterValue(e.target.value);
      payload = buildCustomerPaymentPayload({
        filterName: SelectBxname,
        filterValue: e.target.value,
      });
    }
    fetchCustomerpayments(payload);
  };
  const payloadParams = buildCustomerPaymentPayload();

  const handleDateRangeChange = (name, value) => {
    const nextFromDate = name === "fromDate" ? value : inputFromDate;
    const nextToDate = name === "toDate" ? value : inputToDate;

    if (name === "fromDate") setInputFromDate(value);
    if (name === "toDate") setInputToDate(value);

    if (!isDateRangeValid(nextFromDate, nextToDate)) {
      setDateError("From Date should not be greater than To Date");
      return;
    }
    setDateError("");
    fetchCustomerpayments(
      buildCustomerPaymentPayload({ fromDate: nextFromDate, toDate: nextToDate }),
    );
  };

  const clearDateRange = () => {
    setInputFromDate("");
    setInputToDate("");
    setDateError("");
    fetchCustomerpayments(
      buildCustomerPaymentPayload({ fromDate: "", toDate: "" }),
    );
  };
  const handleDelete = async (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (item?._id) {
          try {
            let payload = {
              paymentId: item?._id,
              ...(item?.paymentIds?.length > 0
                ? { paymentIds: item.paymentIds }
                : {}),
            };
            const response = await deletePayment(payload);

            setMessage(response.message);
            setOpenPopUp(true);
            fetchCustomerpayments(payloadParams);
          } catch (error) {
            Swal.fire("Error deleting payments");
            fetchCustomerpayments(payloadParams);
          }
        }
      }
    });
  };
  const handleEdit = (row) => {
    setSelectedRow(row);
    setEditMode(true);
    let button_type = "";
    console.log(row, "row in handleEdit");
    if (row.paymentType == "received") button_type = "addreceipt";
    else button_type = "addpayment";
    OpenDialog(button_type);
  };
  const NoRowsOverlay = () => (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        color: "gray",
      }}
    >
      <Typography>No Record Found</Typography>
    </Box>
  );

  const columns = [
    { field: "jobId", headerName: "Job ID", flex: 1 },
    {
      field: "quotation",
      headerName: (
        <span>
          Quotation
          <br />
          Number
        </span>
      ),
      flex: 1,
      minWidth: 150,
    },
    { field: "invoice", headerName: "Invoice", flex: 1 },
    {
      field: "recvamount",
      headerName: (
        <span>
          Received
          <br />
          Amount
        </span>
      ),
      flex: 1,
      minWidth: 100,
    },
    {
      field: "amount",
      headerName: (
        <span>
          Paid
          <br />
          Amount
        </span>
      ),
      flex: 1,
      minWidth: 100,
    },
    { field: "currency", headerName: "Currency", flex: 1, minWidth: 100 },
    {
      field: "exchangeLoss",
      headerName: "Exchange Loss",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "discountAmount",
      headerName: `Discount (OMR)`,
      flex: 1,
      minWidth: 100,
    },
    {
      field: "modeofPayment",
      headerName: (
        <span>
          Mode Of
          <br />
          Payment
        </span>
      ),
      flex: 1,
      minWidth: 150,
    },
    { field: "dateofpay", headerName: "Payment Date", flex: 1, minWidth: 120 },
    // { field: "banks", headerName: "Bank", flex: 1 },
    {
      field: "actions",
      headerName: "Action",
      flex: 2,
      renderCell: (params) => (
        <>
          <div style={{ display: "flex", alignItems: "center" }}>
            {(!params.row.amount || params.row.amount === 0) && (
              <button
                className="btn btna submitpaymentbutton btnfsize"
                onClick={() => handleView(params.row)}
                style={{ marginRight: "8px" }}
              >
                View
              </button>
            )}
            <IconButton color="primary" onClick={() => handleEdit(params.row)}>
              <EditIcon sx={{ fontSize: "19px" }} />
            </IconButton>
            {/* Show paymentIcon only if isDirectPayment is true */}
            {params.row.isDirectPayment === true && (
              <img
                src={paymentIcon}
                alt="Direct Payment"
                style={{ width: 22, height: 22, marginLeft: 8, marginRight: 8 }}
              />
            )}
            {currentroleType === "admin" && (
              <>
                <IconButton
                  color="secondary"
                  onClick={() => handleDelete(params.row)}
                >
                  <DeleteIcon sx={{ fontSize: "19px" }} />
                </IconButton>
              </>
            )}{" "}
          </div>
        </>
      ),
    },
  ];

  const handleView = (row) => {
    setSelectedRow(row);
    openViewDialog();
  };
  const openViewDialog = () => {
    handleClickOpenView();
  };
  const handleClickOpenView = () => {
    setviewOpen(true);
  };

  const handleCloseView = () => {
    setviewOpen(false);
    setSelectedRow(null);
  };

  const handleCustomerSelectChange = (selectedOption) => {
    console.log(selectedOption, "selectedOption");

    const customerId = selectedOption ? selectedOption.value : "";
    setSelectedCustomerid(customerId);

    // If no customer selected, do NOT call API
    if (!customerId) return;

    if (!isDateRangeValid(inputFromDate, inputToDate)) {
      setDateError("From Date should not be greater than To Date");
      return;
    }
    setDateError("");
    const payload = buildCustomerPaymentPayload({
      customerIdValue: customerId,
    });

    fetchCustomerpayments(payload);
  };
  // Prepare options for react-select
  const customerOptions = customerList.map((customer) => ({
    value: customer._id,
    label: customer.customerName,
  }));

  return (
    <>
      <div>
        <div className="customer-payment-filters mt-3 mb-3 d-flex align-items-center">
          <div className=" d-flex paymentbycus">
            <label
              htmlFor="exampleFormControlInput1"
              className="form-labele filterbypayment "
            >
              {" "}
              Customer Name:
            </label>
            <div className="vessel-select">
              {/* <select
                className="form-select vesselbox statusscustomerbypayment"
                name="customers"
                value={selectedCustomerid || ""}
                onChange={handleChange}
              >
                {customerList.map((customer) => (
                  <option key={customer._id} value={customer._id}>
                    {customer.customerName} {""}
                  </option>
                ))}
              </select> */}
              <Select
                options={customerOptions}
                onChange={handleCustomerSelectChange}
                value={customerOptions.find(
                  (opt) => opt.value === selectedCustomerid
                )}
                placeholder="Choose Customer Name"
                isClearable
                isSearchable
                styles={customSelectStyles}
                className="paymentcustomer"
                classNamePrefix="react-select"
              />
            </div>
          </div>
          <div className="cccsut mt-2 mb-2">
            <div className="cusbydate">
              <label
                htmlFor="inputPassword"
                className=" form-labele col-form-label text-nowrap"
              >
                From Date:
              </label>
              <div className="">
                <div className="fw-bolder paymentpdafontweight"></div>
              </div>
            </div>
            <div className="">
              <input
                type="date"
                name="fromDate"
                className="datebycustomerpayment form-control vesselbox statusspayment"
                placeholder="Select Date"
                onChange={(e) =>
                  handleDateRangeChange(e.target.name, e.target.value)
                }
                value={inputFromDate}
              />
            </div>
          </div>
          <div className="cccsut mt-2 mb-2">
            <div className="cusbydate">
              <label
                htmlFor="inputPassword"
                className=" form-labele col-form-label text-nowrap"
              >
                To Date:
              </label>
              <div className="">
                <div className="fw-bolder paymentpdafontweight"></div>
              </div>
            </div>
            <div className="">
              <input
                type="date"
                name="toDate"
                className="datebycustomerpayment form-control vesselbox statusspayment"
                placeholder="Select Date"
                onChange={(e) =>
                  handleDateRangeChange(e.target.name, e.target.value)
                }
                value={inputToDate}
              />
            </div>
          </div>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm ms-2 clear-date-btn"
            onClick={clearDateRange}
          >
            Clear Date
          </button>
          <div className="neevocu">
            <div className="voucherbypayment mb-2">
              <i className="bi bi-funnel-fill filtericon"></i>
              <select
                name="pdaId"
                className="form-select form-select-sm filteremployee cupaymentddfont"
                aria-label="Small select example"
                onChange={handleTimeperiod}
              >
                <option value="">Choose Quotation </option>
                {QuotationList.map((invoice) => (
                  <option key={invoice._id} value={invoice._id}>
                    {invoice.pdaNumber}
                    {invoice.invoiceId ? ` - ${invoice.invoiceId}` : ""}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="necus">
            <div className=" d-flex filterpayment">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-labele filterbycustpayment "
              >
                {" "}
                Filter By:
              </label>
              <div className="vessel-select">
                <select
                  name="status"
                  className="form-select vesselbox statussbycustomer"
                  onChange={(e) => setPeriod(e.target.value)}
                  value={period}
                >
                  <option value="">Select Period</option>
                  <option value="month">Monthly</option>
                  <option value="year">Yearly</option>
                </select>
              </div>
            </div>

            <div className="nonvalue">
              {period === "month" && (
                <select
                  name="month"
                  className="form-select jobporrte mmonthcus monthcustomerpay"
                  aria-label="Select Month"
                  onChange={handleTimeperiod}
                >
                  <option value="">Select Month</option>
                  {months.map((month, index) => (
                    <option key={index} value={month.value}>
                      {month.label}
                    </option>
                  ))}
                </select>
              )}

              {period === "year" && (
                <select
                  name="year"
                  className="form-select jobporrt mmonthcus monthcustomerpay"
                  aria-label="Select Year"
                  onChange={handleTimeperiod}
                >
                  <option value="">Select Year</option>
                  {years.map((year, index) => (
                    <option key={index} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              )}
            </div>
          </div>
          <div className="d-flex align-items-center paymentcustomermargin">
            <input
              type="checkbox"
              id="isDirectCustomerPayment"
              checked={isDirectCustomerPayment}
              onChange={(e) => {
                setIsDirectPayment(e.target.checked);
                // Refetch payments with updated isDirectCustomerPayment
                let payload = {
                  ...buildCustomerPaymentPayload({
                    isDirectPayment: e.target.checked ? true : "",
                  }),
                };
                fetchCustomerpayments(payload);
              }}
              style={{ marginRight: "6px" }}
            />
            <label
              htmlFor="isDirectCustomerPayment"
              className="form-labele mb-0"
            >
              Direct Payment
            </label>
          </div>
        </div>
        {dateError && <div className="text-danger mb-2">{dateError}</div>}

        <div className="charge">
          <div className="rectangle"></div>
          <div>
            <img src={Group}></img>
          </div>
        </div>

        <Addpayment
          open={open}
          onClose={handleClose}
          customerId={selectedCustomerid}
          vendorId=""
          ListCustomer={handleListCustomer}
          Balance={balanceAmount}
          editMode={editMode}
          paymentvalues={selectedRow}
          errors={errors}
          setErrors={setErrors}
          buttonType={ButtonId}
          voucherNumber={voucherNumber}
        />

        <div className="paymeamount">
          <div className=" d-flex">
            <div className="totalinvociecustomer">
              {" "}
              Total Invoice Amount(OMR):
            </div>{" "}
            <div className="amountpayment"> {totalInvoiceAmount} </div>
          </div>
          <div className=" d-flex">
            <div className="totalinvociecustomer"> Paid Amount(OMR):</div>{" "}
            <div className="amountpayment"> {paidAmount} </div>
          </div>
          <div className=" d-flex">
            <div className="totalinvociecustomer"> Discount Amount:</div>{" "}
            <div className="amountpayment"> {discountAmount} </div>
          </div>
          <div className=" d-flex">
            <div className="totalinvociecustomer"> Balance Amount(OMR):</div>{" "}
            <div className="amountpayment"> {balanceAmount} </div>
          </div>

          <div className="paymentbtn">
            <button
              onClick={() => {
                OpenDialog("addreceipt");
              }}
              className="btn btn-info infobtn addrecep"
              id="addreceipt"
            >
              Add Receipt
            </button>
            <button
              onClick={() => {
                OpenDialog("addpayment");
              }}
              className="btn btn-info infobtn"
              id="addpayment"
            >
              Add Payment
            </button>
          </div>
        </div>
        <div style={{ width: "100%" }}>
          <DataGrid
            key={`${selectedCustomerid}-${inputFromDate}-${inputToDate}-${inputpdaId}-${FilterName}-${FilterValue}-${isDirectCustomerPayment}`}
            rows={customerpayment.map((item) => {
              // Check if item.pdaIds is an array and contains objects
              /*const pdaIds = Array.isArray(item.pdaIds) ? item.pdaIds.filter(pda => pda.invoiceId).map(pda => pda.invoiceId).join(', '): '';
        const pdaNumbers = Array.isArray(item.pdaIds) ? item.pdaIds.filter(pda => pda.pdaNumber).map(pda => pda.pdaNumber).join(', ') : ''; 
        const jobIds = Array.isArray(item.pdaIds) ? item.pdaIds.filter(pda => pda.jobId).map(pda => pda.jobId).join(', ') : '';*/
              const dateOnly = item.paymentDate.split("T")[0];
              const [year, month, day] = dateOnly.split("-");
              const formattedDate = `${day}-${month}-${year}`;
              const currencyVal = item.currency.toUpperCase();
              const modeofpay =
                item.modeofPayment.charAt(0).toUpperCase() +
                item.modeofPayment.slice(1);
              let receivedamt = "";
              let paidamount = "";
              if (item.paymentType === "received") receivedamt = item.amount;
              else if (item.paymentType === "refundexcess")
                paidamount = item.amount;
              const pdaList = item.pdaList?.length ? item.pdaList : [];
              const jobIds = pdaList.length
                ? pdaList.map((pda) => pda?.jobId || "N/A").join(", ")
                : item.pdaIds.jobId || "N/A";
              const quotations = pdaList.length
                ? pdaList.map((pda) => pda?.pdaNumber || "N/A").join(", ")
                : item.pdaIds.pdaNumber || "N/A";
              const invoices = pdaList.length
                ? pdaList.map((pda) => pda?.invoiceId || "N/A").join(", ")
                : item.pdaIds.invoiceId || "N/A";
              return {
                ...item,
                id: item._id,
                jobId: jobIds,
                quotation: quotations,
                invoice: invoices,
                recvamount: receivedamt,
                amount: paidamount,
                currency: currencyVal || "N/A",
                modeofPayment: modeofpay || "N/A",
                dateofpay: formattedDate || "N/A",
                // banks:
                //   item.bank && item.bank.bankName ? item.bank.bankName : "N/A",
              };
            })}
            columns={columns}
            getRowId={(row) => row._id} // Use id field for unique row identification
            disableSelectionOnClick // Disables checkbox selection to prevent empty column
            disableColumnMenu // Removes column menu
            components={{
              NoRowsOverlay,
            }}
            sx={{
              "& .MuiDataGrid-root": {
                border: "none",
              },
              "& .MuiDataGrid-columnHeader": {
                backgroundColor: "#eee !important", // Set gray background color
                color: "#000000", // Set white text color for contrast
                fontWeight: "bold", // Optional: Make the text bold
              },
              "& .MuiDataGrid-cell": {
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },
              "& .MuiTablePagination-toolbar": {
                alignItems: "baseline", // Apply align-items baseline
              },
              "& .MuiDataGrid-columnHeaderTitle": { fontWeight: "bold" },
              "& .MuiDataGrid-footerContainer": {
                backgroundColor: "#eee", // Gray background for the footer
              },
            }}
            pagination // Enables pagination
            pageSizeOptions={[5, 10, 20, 50, 100]} // Sets available page size options
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10, // Default page size
                  page: 0, // Default page index
                },
              },
            }}
          />
        </div>

        {customerpayment?.length === 0 && (
          <div className="no-data">
            <p>No Data Found</p>
          </div>
        )}
      </div>

      <ViewCustomerVoucher
        open={viewopen}
        onClose={handleCloseView}
        getvoucher={selectedRow}
      />

      {openPopUp && (
        <PopUp message={message} closePopup={() => setOpenPopUp(false)} />
      )}
      <Loader isLoading={isLoading} />
    </>
  );
};

export default CustomerPayments;
